import React, { useState } from "react";
import { Link } from "react-router-dom";
import '../../scss/pages/_forgotpassword.scss';
// image
import logo from "../../images/fhub_icon.png";
import { useHistory } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';

import {
  loadingToggleAction,
  forgotPasswordAction,
} from '../../store/actions/AuthActions';



const ForgotPassword = (props) => {

  const [email, setEmail] = useState();

  const [requestemail, setRequestemail] = useState(false);

  console.log(email);

  const handleRequest = (e) => {

    let valid = validateEmail(e.target.value);

     setEmail(e.target.value);

    if (valid) {
       setRequestemail(true);
    } else {
      setRequestemail(false);
    }
    
  }

  function validateEmail(emailAdress) {
    let regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (emailAdress.match(regexEmail)) {
      return true;
    } else {
      return false;
    }
  }


 

  const dispatch = useDispatch();


  function onLogin(e) {
    
    e.preventDefault();
    dispatch(loadingToggleAction(true));
    dispatch(forgotPasswordAction(email, props.history));
  }

  const history = useHistory();

  return (
    <div className="forgot">
      <div className="card  mx-auto  login-card">
        <div className="card-body">
          <div className="row" style={{ position: 'relative' }}>
            <img className='img-fluid logo-img' src={logo} />
            <p className="text-center forgotp">Forgot Your Password?</p>
            <p className=" text-center no-prbp fs-5">No problem! Just provide your e-mail address and we'll send you a reset link.</p>

            <form onSubmit={onLogin}>
              <div className="form-group mb-3 mt-3 focus">
                <input type="email" className="form-control"
                  value={email} onInput={handleRequest}
                />
                <label className="mb-2 "><strong>E-mail</strong>  </label>
              </div>

              <button type="submit"  className={requestemail ? "forget-text d-flex justify-content-center fs-4 mt-4" : "forget-text-disable  d-flex justify-content-center fs-4 mt-4" } style={{ cursor: 'pointer' }}> <b> Request Login</b> </button>

              <Link onClick={() => history.push("/login")} className="forget-text d-flex justify-content-center fs-4 mt-2" style={{ cursor: 'pointer' }}> <b> Back</b> </Link>
            </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
